// gift-timeline.js

// 1️⃣ Wait for an element to exist in the DOM
function waitForElement(selector, callback, interval = 100, timeout = 5000) {
  const startTime = Date.now();

  const check = () => {
    const el = document.querySelector(selector);
    if (el) {
      callback(el);
    } else if (Date.now() - startTime < timeout) {
      setTimeout(check, interval);
    }
  };

  check();
}

// 2️⃣ Read cart subtotal
function getCartTotal() {
  const subtotalEl = document.querySelector('[data-cart-subtotal]');
  if (!subtotalEl) return 0;
  const totalStr = subtotalEl.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
  return parseFloat(totalStr) || 0;
}

// 3️⃣ Update the gift timeline bubbles & progress
function updateGiftTimeline() {
  const subtotalEl = document.querySelector('[data-cart-subtotal]');
  const progressBar = document.getElementById('gift-progress');
  const iconsContainer = document.getElementById('gift-icons');
  const titleEl = document.getElementById('gift-next-title');

  if (!subtotalEl) {
    if (progressBar) progressBar.style.display = 'none';
    if (iconsContainer) iconsContainer.style.display = 'none';
    if (titleEl) titleEl.style.display = 'none';
    return;
  }

  if (progressBar) progressBar.style.display = 'block';
  if (iconsContainer) iconsContainer.style.display = 'block';
  if (titleEl) titleEl.style.display = 'block';

  const total = getCartTotal();

  const milestones = [
    //{ amount: 50, icon: window.assets.transport5, label: 'Gratis <5 km' },
    { amount: 100, icon: window.assets.transport, label: 'Gratis verzending' },
    { amount: 150, icon: window.assets.gelukzak, label: 'Gratis gelukzak' }
  ];
  const maxAmount = milestones[milestones.length - 1].amount;

  // Update progress bar width
  progressBar.style.width = Math.min((total / maxAmount) * 100, 100) + '%';

  // Clear & render bubbles
  iconsContainer.innerHTML = '';

  let nextGift = null;
  for (let i = 0; i < milestones.length; i++) {
    const m = milestones[i];
    const leftPercent = Math.min((m.amount / maxAmount) * 100, 100);
    const achieved = total >= m.amount;

    // Save first milestone not yet achieved
    if (!achieved && !nextGift) nextGift = m;

    const wrapper = document.createElement('div');
    wrapper.style.position = 'absolute';
    wrapper.style.left = `calc(${leftPercent}% - 20px)`;
    wrapper.style.top = '12px';
    wrapper.style.textAlign = 'center';
    wrapper.style.width = '40px';

    const bubble = document.createElement('div');
    bubble.style.width = '40px';
    bubble.style.height = '40px';
    bubble.style.borderRadius = '50%';
    bubble.style.display = 'flex';
    bubble.style.alignItems = 'center';
    bubble.style.justifyContent = 'center';
    bubble.style.background = achieved ? '#e7927a' : '#fff';
    bubble.style.border = '2px solid #e7927a';
    bubble.style.boxShadow = '0 2px 6px rgba(0,0,0,0.1)';
    bubble.style.transition = 'all 0.3s ease';

    //const icon = document.createElement('span');
    //icon.textContent = m.icon;
    //icon.style.fontSize = '18px';
    //bubble.appendChild(icon);

    const icon = document.createElement('img');
    icon.src = m.icon;
    icon.style.width = '25px';
    icon.style.height = '25px';

    bubble.appendChild(icon);

    const label = document.createElement('div');
    label.style.fontSize = '12px';
    label.style.marginTop = '6px';
    if (achieved) {
      label.textContent = 'Gratis!';
      label.style.color = 'black';
      label.style.fontWeight = 'bold';
    } else {
      label.textContent = m.label;
      label.style.color = '#999';
    }

    wrapper.appendChild(bubble);
    wrapper.appendChild(label);
    iconsContainer.appendChild(wrapper);
  }

  // Update the "Next gift" title
  if (titleEl) {
    if (nextGift) {
      const remaining = nextGift.amount - total;
      titleEl.textContent = `Nog ${remaining.toLocaleString('nl-BE', {
        style: 'currency',
        currency: 'EUR'
      })} voor een ${nextGift.label.toLowerCase()}`;
    } else {
      titleEl.textContent = `Je hebt alle cadeaus vrijgespeeld!`;
      titleEl.style.fontWeight = 'bold';
    }
  }
}

function initGiftTimeline() {
  const observeSubtotal = () => {
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (!subtotalEl){
        const timeline = document.getElementById('gift-timeline');
        if (timeline) timeline.style.display = 'none';
        return;
    } 

    if (subtotalEl.__giftObserver) return;

    const observer = new MutationObserver(() => updateGiftTimeline());
    observer.observe(subtotalEl, {
      childList: true,
      subtree: true,
      characterData: true
    });

    subtotalEl.__giftObserver = observer;
    updateGiftTimeline();
  };

  const bodyObserver = new MutationObserver(() => observeSubtotal());
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  observeSubtotal();
}

// 5️⃣ Hook into page events
document.addEventListener('DOMContentLoaded', initGiftTimeline);
document.addEventListener('drawer:open', initGiftTimeline);

if (window.subscribe) {
  window.subscribe('cartUpdate', initGiftTimeline);
}